import * as React from 'react';

interface ClassDetails {
  name: string;
  date: string;
  time: string;
  duration: string;
  location: string;
  instructor: string;
  meetingLink?: string;
}

interface ClassReminderEmailProps {
  name?: string;
  company?: string;
  supportEmail?: string;
  domain?: string;
  classDetails?: ClassDetails;
  accountLink?: string;
}

export const ClassReminderEmail: React.FC<ClassReminderEmailProps> = ({
  name = 'João Silva',
  company = 'Trivium',
  supportEmail = 'suporte@trivium.com.br',
  domain = 'trivium.com.br',
  classDetails = {
    name: 'Introdução ao TypeScript',
    date: '15/08/2023',
    time: '19:00',
    duration: '1 hora e 30 minutos',
    location: 'Online (Zoom)',
    instructor: 'Ana Souza',
    meetingLink: 'https://zoom.us/j/1234567890',
  },
  accountLink = 'https://trivium.com.br/minha-conta',
}) => {
  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <img 
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Logo%20Trivium%20Rebranded%20Branco%20150%20dpi-0VfiiO2tOZNdZlvY5A7z3saYZGysgq.png" 
          alt="Trivium"
          style={logoImageStyle}
        />
      </div>
      
      {/* Content */}
      <div style={contentStyle}>
        <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ backgroundColor: '#E7F5FB' }}>
          <tr>
            <td align="center" style={{ padding: '40px 20px' }}>
              <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ maxWidth: '400px' }}>
                {/* Círculo com ícone */}
                <tr>
                  <td align="center" style={{ paddingBottom: '30px' }}>
                    <div style={{ 
                      width: '60px', 
                      height: '60px', 
                      borderRadius: '50%', 
                      backgroundColor: '#1F1746', 
                      display: 'inline-block',
                      textAlign: 'center',
                      lineHeight: '60px'
                    }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
                        <path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" fill="white"/>
                      </svg>
                    </div>
                  </td>
                </tr>
                
                {/* Título */}
                <tr>
                  <td align="center" style={{ paddingBottom: '15px' }}>
                    <h1 style={{ 
                      margin: '0',
                      fontSize: '28px',
                      color: '#333333',
                      fontWeight: '600'
                    }}>
                      Lembrete de Aula
                    </h1>
                  </td>
                </tr>
                
                {/* Mensagem */}
                <tr>
                  <td align="center" style={{ paddingBottom: '25px' }}>
                    <p style={{ 
                      margin: '0',
                      fontSize: '16px',
                      color: '#666666'
                    }}>
                      Sua aula começa em 24 horas
                    </p>
                  </td>
                </tr>
                
                {/* Badge */}
                <tr>
                  <td align="center">
                    <div style={{ 
                      backgroundColor: '#3E5FBA',
                      borderRadius: '24px',
                      color: '#FFFFFF',
                      fontWeight: '600',
                      fontSize: '15px',
                      padding: '12px 25px',
                      display: 'inline-block'
                    }}>
                      {classDetails.date} às {classDetails.time}
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        
        <div style={contentContainerStyle}>
          <h2 style={titleStyle}>Olá, {name}!</h2>
          
          <p style={paragraphStyle}>
            Estamos enviando este lembrete para sua aula de <strong>{classDetails.name}</strong> que 
            está agendada para começar em <strong>24 horas</strong>.
          </p>
          
          <p style={paragraphStyle}>
            Por favor, verifique os detalhes abaixo e prepare-se para a aula. Se você tiver alguma
            dúvida ou precisar reagendar, entre em contato conosco o mais rápido possível.
          </p>
        </div>
        
        <div style={courseCardStyle}>
          <div style={courseHeaderStyle}>
            <h3 style={courseTitleStyle}>{classDetails.name}</h3>
          </div>
          
          <div style={courseDetailsStyle}>
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Data:</div>
                <div style={detailValueStyle}>{classDetails.date}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Horário:</div>
                <div style={detailValueStyle}>{classDetails.time} ({classDetails.duration})</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Local:</div>
                <div style={detailValueStyle}>{classDetails.location}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Instrutor:</div>
                <div style={detailValueStyle}>{classDetails.instructor}</div>
              </div>
            </div>
            
            {classDetails.meetingLink && (
              <div style={{ marginTop: '20px' }}>
                <a href={classDetails.meetingLink} style={linkButtonStyle} target="_blank" rel="noopener noreferrer">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle', marginRight: '8px' }}>
                    <path d="M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zm-2-.79V18H4V6h12v3.69z" fill="white"/>
                  </svg>
                  Acessar Aula Online
                </a>
              </div>
            )}
          </div>
        </div>
        
        <div style={preparationStyle}>
          <h3 style={preparationTitleStyle}>Como se preparar</h3>
          <ul style={checklistStyle}>
            <li style={checklistItemStyle}>
              <span style={checkIconStyle}>✓</span>
              Verifique sua conexão com a internet antes da aula
            </li>
            <li style={checklistItemStyle}>
              <span style={checkIconStyle}>✓</span>
              Tenha papel e caneta em mãos para anotações
            </li>
            <li style={checklistItemStyle}>
              <span style={checkIconStyle}>✓</span>
              Acesse a aula 5 minutos antes do horário programado
            </li>
            <li style={checklistItemStyle}>
              <span style={checkIconStyle}>✓</span>
              Certifique-se de que seu microfone e câmera estão funcionando
            </li>
          </ul>
        </div>
        
        <div style={ctaContainerStyle}>
          <p style={ctaTextStyle}>
            Você pode gerenciar suas aulas e visualizar materiais adicionais através da sua conta:
          </p>
          <div style={buttonContainerStyle}>
            <a href={accountLink} style={buttonStyle}>
              Acessar Minha Conta
            </a>
          </div>
        </div>
        
        <hr style={hrStyle} />
        
        <div style={footerContentStyle}>
          <p style={footerStyle}>
            Se você tiver alguma dúvida ou precisar reagendar sua aula, entre em contato conosco:
          </p>
          <div style={contactChannelsStyle}>
            <p style={contactChannelStyle}>✉️ {supportEmail}&nbsp;&nbsp;📱 (11) 3181-5940</p>
          </div>
          <p style={footerStyle}>
            Estamos ansiosos para vê-lo em aula!<br />
            Equipe {company}
          </p>
        </div>
      </div>
      
      {/* Footer */}
      <div style={emailFooterStyle}>
        <p style={copyrightStyle}>
          © 2025 {company}. Todos os direitos reservados.
        </p>
        <div style={footerLinksStyle}>
          <a href={`https://${domain}/termos`} style={footerLinkStyle}>Termos de Uso</a>
          <span style={footerDividerStyle}>|</span>
          <a href={`https://${domain}/privacidade`} style={footerLinkStyle}>Política de Privacidade</a>
        </div>
      </div>
    </div>
  );
};

// Estilos
const brandColor = '#1F1746';
const accentColor = '#3E5FBA';
const backgroundColor = '#F5F7FA';
const textColor = '#333333';
const secondaryTextColor = '#666666';

const containerStyle = {
  fontFamily: "'Satoshi', Arial, sans-serif",
  maxWidth: '600px',
  margin: '0 auto',
  backgroundColor: backgroundColor,
};

const headerStyle = {
  backgroundColor: brandColor,
  padding: '25px',
  textAlign: 'center' as const,
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
};

const logoImageStyle = {
  maxWidth: '180px',
  height: 'auto',
  display: 'block',
  margin: '0 auto',
};

const contentStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '0 0 8px 8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
  padding: '0',
  margin: '0 0 20px 0',
  overflow: 'hidden',
};

const contentContainerStyle = {
  padding: '0 40px',
};

const titleStyle = {
  fontSize: '24px',
  fontWeight: '600',
  color: brandColor,
  marginBottom: '16px',
  padding: '24px 0 0 0',
};

const paragraphStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  color: textColor,
  margin: '16px 0',
};

const courseCardStyle = {
  border: '1px solid #E1E4E8',
  borderRadius: '8px',
  overflow: 'hidden',
  margin: '24px 40px',
};

const courseHeaderStyle = {
  backgroundColor: brandColor,
  padding: '16px 24px',
};

const courseTitleStyle = {
  margin: '0',
  color: '#ffffff',
  fontSize: '18px',
  fontWeight: '600',
};

const courseDetailsStyle = {
  padding: '20px 24px',
  backgroundColor: '#ffffff',
};

const detailBlockStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: '16px',
};

const detailIconContainerStyle = {
  width: '24px',
  marginRight: '12px',
  paddingTop: '2px',
};

const detailLabelStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  fontWeight: '500',
  marginBottom: '4px',
};

const detailValueStyle = {
  fontSize: '15px',
  color: textColor,
  fontWeight: '500',
};

const linkButtonStyle = {
  backgroundColor: accentColor,
  color: '#ffffff',
  padding: '10px 16px',
  borderRadius: '6px',
  textDecoration: 'none',
  fontSize: '14px',
  fontWeight: '600',
  display: 'inline-block',
};

const preparationStyle = {
  padding: '24px 40px',
  backgroundColor: '#F8F9FA',
  margin: '24px 40px',
  borderRadius: '8px',
};

const preparationTitleStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: brandColor,
  margin: '0 0 16px 0',
};

const checklistStyle = {
  listStyleType: 'none',
  margin: '0',
  padding: '0',
};

const checklistItemStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  fontSize: '15px',
  color: textColor,
  marginBottom: '12px',
  lineHeight: '22px',
};

const checkIconStyle = {
  color: '#4CAF50',
  fontWeight: 'bold',
  marginRight: '8px',
};

const ctaContainerStyle = {
  padding: '24px 40px',
};

const ctaTextStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  color: textColor,
  margin: '0 0 16px 0',
};

const buttonContainerStyle = {
  textAlign: 'center' as const,
  margin: '24px 0',
};

const buttonStyle = {
  backgroundColor: brandColor,
  borderRadius: '6px',
  color: '#fff',
  fontSize: '16px',
  fontWeight: '600',
  textDecoration: 'none',
  padding: '12px 24px',
  display: 'inline-block',
  transition: 'background-color 0.3s ease',
};

const hrStyle = {
  borderColor: '#E1E4E8',
  margin: '24px 40px',
};

const footerContentStyle = {
  padding: '0 40px 32px 40px',
};

const footerStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  margin: '8px 0',
};

const contactChannelsStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  marginBottom: '20px',
  marginTop: '8px',
};

const contactChannelStyle = {
  fontSize: '15px',
  color: textColor,
  margin: '6px 0',
  fontWeight: '500',
};

const emailFooterStyle = {
  backgroundColor: backgroundColor,
  padding: '24px 40px',
  textAlign: 'center' as const,
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
};

const copyrightStyle = {
  fontSize: '13px',
  color: secondaryTextColor,
  margin: '0 0 12px 0',
};

const footerLinksStyle = {
  margin: '8px 0',
};

const footerLinkStyle = {
  color: brandColor,
  textDecoration: 'none',
  fontSize: '13px',
  fontWeight: '500',
};

const footerDividerStyle = {
  color: secondaryTextColor,
  margin: '0 8px',
};

export default ClassReminderEmail; 